import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "7.613",
      cy: "8.106",
      r: "6.9",
      stroke: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7.613",
      cy: "8.106",
      r: "3.342",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }